module.exports = "<ngx-loading [show]=\"loadingMap\"></ngx-loading>\n<div id=\"map\" class=\"map\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/locations-map/locations-map.component.html
// module id = ./src/app/shared/locations-map/locations-map.component.html
// module chunks = main